import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#home-value-app', App);
